<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form
        :model="where"
        label-width="77px"
        class="ele-form-search"
        @keyup.enter.native="reload"
        @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="12" :md="24">
            <el-form-item label="选择时间">
              <div class="recon-time-wrap">
                <el-radio-group v-model="timeQuick" size="small" @change="onTimeQuickChange">
                  <el-radio-button label="today">今日</el-radio-button>
                  <el-radio-button label="yesterday">昨日</el-radio-button>
                  <el-radio-button label="week">本周</el-radio-button>
                  <el-radio-button label="month">本月</el-radio-button>
                  <el-radio-button label="lastMonth">上月</el-radio-button>
                  <el-radio-button label="days30">30日</el-radio-button>
                </el-radio-group>
                <el-date-picker
                  v-model="where.time"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="onTimePickerChange" />
              </div>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <div class="recon-stat-bar">
        <span>盈利(收): {{ summary.in_profit }}</span>
        <span>盈利(付): {{ summary.out_profit }}</span>
        <span>纯盈利: {{ summary.yingli }}</span>
      </div>

      <ele-pro-table
        ref="table"
        :where="where"
        :datasource="loadData"
        :columns="columns"
        :need-page="false"
        height="calc(100vh - 360px)" />
    </el-card>
  </div>
</template>

<script>
import reconTime from '@/mixins/recon-time';

const EMPTY_SUMMARY = {
  in_profit: '0.00',
  out_profit: '0.00',
  yingli: '0.00'
};

export default {
  name: 'ShouyiRecon',
  mixins: [reconTime],
  data() {
    return {
      columns: [
        { prop: 'name', label: '货币类型', minWidth: 100, align: 'center', showOverflowTooltip: true },
        { prop: 'in_profit', label: '盈利(收)', minWidth: 120, align: 'center', showOverflowTooltip: true },
        { prop: 'out_profit', label: '盈利(付)', minWidth: 120, align: 'center', showOverflowTooltip: true },
        { prop: 'yingli', label: '纯盈利', minWidth: 120, align: 'center', showOverflowTooltip: true }
      ],
      where: { time: null },
      summary: { ...EMPTY_SUMMARY }
    };
  },
  methods: {
    loadData(params, callback) {
      const where = (params && params.where) || this.where || {};
      this.$http
        .get('/Reconciliation/profit', { params: { time: where.time || undefined } })
        .then((res) => {
          if (res.data.code !== 0) {
            this.summary = { ...EMPTY_SUMMARY };
            this.$message.error(res.data.msg);
            callback([]);
            return;
          }
          this.summary = { ...EMPTY_SUMMARY, ...(res.data.summary || {}) };
          callback(Array.isArray(res.data.data) ? res.data.data : []);
        })
        .catch((e) => {
          this.summary = { ...EMPTY_SUMMARY };
          this.$message.error(e.message);
          callback([]);
        });
    },
    reload() {
      this.$refs.table && this.$refs.table.reload({ where: this.where });
    },
    reset() {
      this.where = { time: null };
      this.applyTimeQuick('today', true);
    }
  }
};
</script>

<style scoped src="@/styles/recon-stat.css"></style>
